<template>
    <v-layout v-if="userProfile.active" row wrap :class="['member-profile', routeConfigHideHeader && 'no-header-layout']">
      <div v-if="routeConfigEngagementApp" class="disabled-overlay disabled-overlay--transparent"></div>
        <v-flex v-if="$route.query.name === 'Champs'" xs12 class="back-to">
            <a data-qe-id="memberprofile_backBtn" @click="$router.go(-1)" ><i class="fas fa-arrow-left"></i>{{memberProfileConstants.BACK}}</a>
        </v-flex>
        <v-flex xs12 v-else class="back-to">
            <a data-qe-id="memberprofile_backBtn" @click="$router.go(-1)" v-if="$route.query.name"><i class="fas fa-arrow-left"></i>{{memberProfileConstants.BACK_TO}} {{$route.query.name}}</a>
        </v-flex>
        <v-layout row wrap>
          <v-flex md8 pr-4 class="profile__block">
                <v-flex class="visible-sm">
                    <profile-effectiveness :memberId="memberId" />
                </v-flex>
                <member-profile-header :isConnected="isConnected"
                                        @update:isConnected="isConnected = $event" 
                                        @scroll-to-contact="scrollToContactSection" 
                                        :memberId="memberId" />
                <v-flex class="profile-links hidden-xs">
                    <!-- <a href="#" data-qe-id="memberprofile_professionalExperience" v-if="isProfessionalExperienceVisible || isCurrentUser" v-scroll-to="{ el: '#ProfessionalExperience', offset: -100 }">{{memberProfileConstants.PROFESSIONAL_EXPERIENCE}}</a> -->
                    <a href="#" data-qe-id="memberprofile_ypoCommunities" v-if="isYpoCommunitiesVisible && !isFormerMember || isCurrentUser" v-scroll-to="{ el: '#YpoCommunities', offset: -100 }">{{memberProfileConstants.MY_YPO_COMMUNITIES}}</a>
                    <a href="#" data-qe-id="memberprofile_aboutMe" v-if="isAboutMeVisible || isCurrentUser" v-scroll-to="{ el: '#AboutMe', offset: -100 }">{{memberProfileConstants.ABOUT_ME}}</a>
                    <a href="#" data-qe-id="memberprofile_myContactInformation" v-scroll-to="{ el: '#MyContactInformation', offset: -100 }">{{memberProfileConstants.MY_CONTACT_INFORMATION}}</a>
                    <a href="#" data-qe-id="memberprofile_assetSummary" v-if="assetsShortcutVisible" v-scroll-to="{ el: '#AssetsSummary', offset: -100 }">{{memberProfileConstants.MY_ASSETS_SUMMARY}}</a>
                </v-flex>
              <v-layout v-if="!isImpersonationMode && displayAdminTools" column class="impersonate impersonate--mobile" mb-3>
                <v-flex tag="h3">{{memberProfileConstants.ADMIN_TOOLS}}</v-flex>
                <v-flex pb-2 pt-4 pl-3>
                  <v-btn class="impersonate__btn" @click="impersonate">{{memberProfileConstants.IMPERSONATE}}</v-btn>
                </v-flex>
                <v-flex pl-3 v-if="canAllowImpersonation" class="relative-position">
                  <v-btn :class="['impersonate__btn', 'relative-position', canUserImpersonate ? 'impersonate__btn--disable' : '']"
                         :disabled="isSavingImpersonation.pending"
                         @click="allowImpersonation">
                    <status-overlay :action="isSavingImpersonation" v-if="isSavingImpersonation.pending" content-height="200px">
                    </status-overlay>
                    <span v-else>{{manageImpersonationLabel}}</span>
                  </v-btn>
                </v-flex>
              </v-layout>
                <MyActivity :memberId="memberId" v-if="!isFormerMember && isMyActivityVisible" />
                <ProfessionalExperience v-if="!isChapterManager || isExchangeTestChapter" :memberId="memberId" id="ProfessionalExperience" />
                <ProfessionalRoles :memberId="memberId" />
                <Company-investments :memberId="memberId" />
                <YpoCommunities :memberId="memberId" id="YpoCommunities" />
                <ChampionPositions :memberId="memberId" />
                <Ypo-awards :memberId="memberId" />
                <About-me :memberId="memberId" id="AboutMe" :isFormerMember="isFormerMember" />
            </v-flex>
          <v-flex md4>
            <v-layout column>
              <v-flex xs12 pb-2 v-if="!isImpersonationMode && displayAdminTools">
                <v-layout column class="impersonate impersonate--desktop">
                  <v-flex tag="h3" mb-3>{{memberProfileConstants.ADMIN_TOOLS}}</v-flex>
                  <v-flex pb-2 pl-3 v-if="canImpersonate">
                    <v-btn class="impersonate__btn" @click="impersonate">{{memberProfileConstants.IMPERSONATE}}</v-btn>
                  </v-flex>
                  <v-flex pl-3 v-if="canAllowImpersonation">
                    <v-btn :disabled="isSavingImpersonation.pending"
                           @click="allowImpersonation"
                           :class="['impersonate__btn', 'relative-position', canUserImpersonate ? 'impersonate__btn--disable' : '']">
                      <status-overlay :action="isSavingImpersonation" v-if="isSavingImpersonation.pending" content-height="200px">
                      </status-overlay>
                      <span v-else>{{manageImpersonationLabel}}</span>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex ref="contactSection" xs12>
                <reasons-to-connect :memberId="memberId"/>
                <v-flex class="contact-me" v-if="!isCurrentUser && !isFormerMember">
                  <v-flex tag="h3">{{memberProfileConstants.BEST_WAYS_CONNECT_WITH_ME}}</v-flex>
                  <v-layout row wrap>
                    <v-flex
                        tag="span"
                        data-qe-id="ypomessenger"
                        @click="openMessengerPage()"
                        :isConnected="isConnected">
                      <i class="fas fa-comments"></i>
                      <v-flex tag="strong">{{memberProfileConstants.MESSAGE_ME}}</v-flex>
                      <v-flex tag="small">{{memberProfileConstants.YPO_MESSENGER}}</v-flex>
                    </v-flex>
                    <!-- TODO: Dummy Data for rest of the Best ways to contact me section. It will be replaced when User Story is created-->
                    <v-flex tag="span" v-if="contactInformation.emailAddresstoDisplay"><i class="fas fa-envelope"></i>
                      <v-flex tag="strong"><a
                          @click="trackContactMemberEmail"
                          :href="`mailto:${contactInformation.emailAddresstoDisplay}`"
                          data-qe-id="memberprofile_primaryEmail">{{contactInformation.emailAddresstoDisplay}}</a></v-flex>
                    </v-flex>
                  </v-layout>
                  <v-flex tag="span" v-if="contactInformation.businessPhoneOnProfile && contactInformation.businessPhone">
                    <a slot="activator" data-qe-id="memberprofile_businessPhoneExt" @click="trackContactMemberPhone" :href="`tel:${BusinessPhoneNumberFormat(contactInformation.countryCode,contactInformation.businessPhone,contactInformation.businessPhoneExt)}`">
                      <i slot="activator" class="fas fa-phone"></i>
                    </a>
                    <a slot="activator" data-qe-id="memberprofile_businessPhone" @click="trackContactMemberPhone" :href="`tel:${PhoneNumberFormat(contactInformation.countryCode,contactInformation.businessPhone)}`">
                      <v-flex tag="strong" slot="activator">{{PhoneNumberFormat(contactInformation.countryCode,contactInformation.businessPhone)}}</v-flex>
                    </a>
                    <v-flex tag="small">{{memberProfileConstants.CONTACT_INFORMATION.BUSINESS}}{{contactInformation.textMsgonBusinessPhone ? memberProfileConstants.CONTACT_INFORMATION.TEXT : "" }}</v-flex>
                  </v-flex>
                  <v-flex tag="span" v-if="contactInformation.mobilePhoneOnProfile && contactInformation.mobilePhone">
                    <a slot="activator" data-qe-id="memberprofile_mobilePhone" @click="trackContactMemberPhone" :href="`tel:${PhoneNumberFormat(contactInformation.mobilePhoneCountryCode,contactInformation.mobilePhone)}`">
                      <i slot="activator" class="fas fa-phone"></i>
                    </a>
                    <a slot="activator" data-qe-id="memberprofile_mobilePhone" @click="trackContactMemberPhone" :href="`tel:${PhoneNumberFormat(contactInformation.mobilePhoneCountryCode,contactInformation.mobilePhone)}`">
                      <v-flex tag="strong" slot="activator">{{PhoneNumberFormat(contactInformation.mobilePhoneCountryCode,contactInformation.mobilePhone)}}</v-flex>
                    </a>
                    <v-flex tag="small">{{memberProfileConstants.CONTACT_INFORMATION.MOBILE}}{{contactInformation.textMsgonMobilePhone ? memberProfileConstants.CONTACT_INFORMATION.TEXT : "" }}</v-flex>
                  </v-flex>
                  <v-flex tag="span" v-if="contactInformation.homePhoneOnProfile && contactInformation.homePhone">
                    <a slot="activator" data-qe-id="memberprofile_homePhone" @click="trackContactMemberPhone" :href="`tel:${PhoneNumberFormat(contactInformation.homePhoneCountryCode,contactInformation.homePhone)}`">
                      <i slot="activator" class="fas fa-phone"></i>
                    </a>
                    <a slot="activator" data-qe-id="memberprofile_homePhone" @click="trackContactMemberPhone" :href="`tel:${PhoneNumberFormat(contactInformation.homePhoneCountryCode,contactInformation.homePhone)}`">
                      <v-flex tag="strong" slot="activator">{{PhoneNumberFormat(contactInformation.homePhoneCountryCode,contactInformation.homePhone)}}</v-flex>
                    </a>
                    <v-flex tag="small">{{memberProfileConstants.HOME}}{{contactInformation.textMsgonHomePhone ? memberProfileConstants.CONTACT_INFORMATION.TEXT : "" }}</v-flex>
                  </v-flex>
                  <v-flex tag="span" v-if="contactInformation.otherPhoneOnProfile && contactInformation.otherPhone">
                    <a slot="activator" data-qe-id="memberprofile_otherPhone" @click="trackContactMemberPhone" :href="`tel:${PhoneNumberFormat(contactInformation.otherPhoneCountryCode,contactInformation.otherPhone)}`">
                      <i slot="activator" class="fas fa-phone"></i>
                    </a>
                    <a slot="activator" data-qe-id="memberprofile_otherPhone" @click="trackContactMemberPhone" :href="`tel:${PhoneNumberFormat(contactInformation.otherPhoneCountryCode,contactInformation.otherPhone)}`">
                      <v-flex tag="strong" slot="activator">{{PhoneNumberFormat(contactInformation.otherPhoneCountryCode,contactInformation.otherPhone)}}</v-flex>
                    </a>
                    <v-flex tag="small">{{memberProfileConstants.OTHER}}{{contactInformation.textMsgonOtherPhone ? memberProfileConstants.CONTACT_INFORMATION.TEXT : ""}}</v-flex>
                  </v-flex>
                  <v-flex tag="span" v-if="contactInformation.whatsAppPhone">
                    <a slot="activator" data-qe-id="memberprofile_whatsAppPhone" @click="trackContactMemberPhone" target="_blank" :href="`https://wa.me/${formatPhoneForNumbersOnly(contactInformation.whatsAppCode,contactInformation.whatsAppPhone)}`">
                      <i slot="activator" class="fab fa-whatsapp"></i>
                    </a>
                    <a slot="activator" data-qe-id="memberprofile_whatsAppPhone" @click="trackContactMemberPhone" target="_blank" :href="`https://wa.me/${formatPhoneForNumbersOnly(contactInformation.whatsAppCode,contactInformation.whatsAppPhone)}`">
                      <v-flex tag="strong" slot="activator">{{PhoneNumberFormat(contactInformation.whatsAppCode,contactInformation.whatsAppPhone)}}</v-flex>
                    </a>
                    <v-flex tag="small">{{memberProfileConstants.CONTACT_INFORMATION.WHATSAPP}}</v-flex>
                  </v-flex>
                </v-flex>
                <v-flex class="hidden-sm">
                  <ProfileEffectiveness :memberId="memberId" />
                </v-flex>
                <!-- TODO: Need to remove v-if when YPO Activity feed related work began-->
                <Share :memberId="memberId" v-if="false"></Share>
                <!-- TODO: Need to remove v-if when My Activityrelated work began-->
                <MyActivity :memberId="memberId" v-if="false && !isFormerMember && isCurrentUser && !isMyActivityVisible" />
                <M2mx :memberId="memberId" v-if="canViewM2mx"></M2mx>
                <Events :memberId="memberId" v-if="!isFormerMember" />
                <Business-expertise :memberId="memberId" />
                <MyContactInformation :memberId="memberId" id="MyContactInformation" />
                <Education :memberId="memberId" />
                <Accomplishments :memberId="memberId" />
                <Training-certification :memberId="memberId" />
              </v-flex>
            </v-layout>

            </v-flex>
        </v-layout>
      <v-flex>
        <AssetsSummary :memberId="memberId" id="AssetsSummary" v-if="assetsShortcutVisible" />
      </v-flex>
        <v-dialog v-model="dialog" width="500">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    {{memberProfileConstants.MY_ACTIVITY}}
                </v-card-title>
                <v-card-text class="inner-scrollbar">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" data-qe-id="close_dialog_btn" flat @click="dialog = false">
                        {{appCommonConstants.CLOSE}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-layout>
    <v-layout v-else row wrap class="member-profile">
        <v-flex xs12 text-xs-center ma-5 class="profile__block">
            <status-overlay :action="loadGetUserProfileAction" v-if="loadGetUserProfileAction.pending" content-height="200px">
            </status-overlay>
            {{memberProfileConstants.PROFILE_NOT_EXISTS_MESSAGE}}
        </v-flex>
    </v-layout>
</template>

<script>
    import { memberProfileConstants } from "./memberProfile.constants.js";
    import { appCommonConstants, routerNames } from "../appCommon.constants.js";
    import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
    import { storeGetters } from "../../store/storeGetters.constant";
    import { storeAction } from "../../store/storeActions.constant";
    import { storeMutation } from "../../store/storeMutations.constant";
    import AboutMe from "./AboutMe";
    import Accomplishments from "./Accomplishments";
    import BusinessExpertise from "./BusinessExpertise_Interest";
    import CompanyInvestments from "./CompanyInvestments";
    import ChampionPositions from "./ChampionPositions";
    import Education from "./Education";
    import ProfessionalExperience from "./ProfessionalExperience";
    import Events from "./Events";
    import M2mx from "./M2MX";
    import MyActivity from "./MyActivity";
    import MemberProfileHeader from "./MemberProfileHeader";
    import MyContactInformation from "./MyContactInformation";
    import ProfileEffectiveness from "./ProfileEffectiveness";
    import ProfessionalRoles from "./ProfessionalRoles";
    import ReasonsToConnect from "./ReasonsToConnect";
    import TrainingCertification from "./TrainingCertification";
    import Share from "./Share";
    import StatusOverlay from '../StatusOverlay/StatusOverlay';
    import YpoAwards from "./YpoAwards";
    import YpoCommunities from "./YpoCommunities";
    import AssetsSummary from "./AssetsSummary";
    import { appConstant } from "@/app.constant";
    import { gaDataLayerEvent } from "@/plugins/analytics";
    import { gtmEventName } from "@/plugins/gtmAnalytics";
    import { formatPhoneNumberForDisplay } from "@/common/utils/phoneUtils";

    export default {
        name: "MemberProfile",
        data: () => ({
            memberProfileConstants,
            appCommonConstants,
            memberId: null,
            isConnected: null,
            dialog: false,
        }),
        components: {
            AboutMe,
            Accomplishments,
            AssetsSummary,
            BusinessExpertise,
            CompanyInvestments,
            ChampionPositions,
            Education,
            ProfileEffectiveness,
            ProfessionalExperience,
            Events,
            M2mx,
            MyActivity,
            MemberProfileHeader,
            MyContactInformation,
            ProfessionalRoles,
            ReasonsToConnect,
            TrainingCertification,
            Share,
            StatusOverlay,
            YpoAwards,
            YpoCommunities,
        },
        created() {
            this.memberId = this.$route.query.memberId; //this id represents contact id. So,pass this id during any api calling.
            this.getUserProfile(this.memberId).then(() => {
                this.setAssetSummaryShortcut(false);
                this.getCurrentUserId().then(() => {
                    this.getAssetSummaryShortcut(this.memberId);
                });
                this.getChapterAdmin(this.memberId);
                if (!this.$store.getters[`memberProfile/${storeGetters.isFamilyInterestsLoading}`]) {
                    this.getFamilyInterests(this.$route.query.memberId);
                }
                this.getProfileDropDowns();
            });
        },
        beforeRouteUpdate: (to, from, next) => {
            next(window.scrollTo(0, 0));
        },
        methods: {
            ...mapActions({
                getUserProfile: `memberProfile/${storeAction.getUserProfile}`,
                getCurrentUserId: `memberProfile/${storeAction.getCurrentUserId}`,
                getFamilyInterests: `memberProfile/${storeAction.getFamilyInterests}`,
                getAssetSummaryShortcut: `memberProfile/${storeAction.getAssetSummaryShortcut}`,
                getChapterAdmin: `memberProfile/${storeAction.getChapterAdmin}`,
                getProfileDropDowns: `memberProfile/${storeAction.getProfileDropDowns}`,
                saveImpersonationRole: `memberProfile/${storeAction.saveImpersonationRole}`,
            }),
            ...mapMutations({
                setAssetSummaryShortcut: `memberProfile/${storeMutation.setAssetSummaryShortcut}`,
            }),
            impersonate() {
              if (this.currentUserId && this.memberId
                  && this.memberId.toLowerCase() !== this.currentUserId.toLowerCase()) {
                sessionStorage.setItem(appConstant.storageKeys.impersonationKey, this.memberId.toLowerCase());
                this.$router.go();
              }
            },
            allowImpersonation() {
              if (this.saveImpersonationRole) this.saveImpersonationRole(this.memberId);
            },
            PhoneNumberFormat(countryCode, phoneNumber) {
                if (phoneNumber) {
                    if (countryCode && phoneNumber.length >= memberProfileConstants.PHONE_NUMBER_LENGTH) {
                        return formatPhoneNumberForDisplay(countryCode, phoneNumber);
                    } else if (phoneNumber.length >= memberProfileConstants.PHONE_NUMBER_LENGTH) {
                        return phoneNumber;
                    }
                }
            },
          formatPhoneForNumbersOnly(areaCode, phoneNum) {
            let result = '';
            if (areaCode && phoneNum) {
              const combinedNumber = (`${areaCode}${phoneNum}`).split('');
              combinedNumber.forEach((item) => {
                // eslint-disable-next-line
                if (!isNaN(parseInt(item))) {
                  result += item;
                }
              });
            }
            return result;
          },
            BusinessPhoneNumberFormat(countryCode, phoneNumber, extension) {
                const businessPh = this.PhoneNumberFormat(countryCode, phoneNumber);
                if (extension) {
                    if (businessPh) {
                        return `${businessPh} ${extension}`;
                    }
                }
            },
            openMessengerPage() {
              gaDataLayerEvent(gtmEventName.C_Profile_Contact_Profile_Initiated, `Chat - ${this.memberId}`);
                this.$router.push({
                    name: routerNames.MESSENGER,
                    query: { to: this.memberId },
                });
            },
          trackContactMemberEmail() {
            gaDataLayerEvent(gtmEventName.C_Profile_Contact_Profile_Initiated, `Email - ${this.memberId}`);
          },
          trackContactMemberPhone() {
            gaDataLayerEvent(gtmEventName.C_Profile_Contact_Profile_Initiated, `Phone - ${this.memberId}`);
          },
          scrollToContactSection() {
            const el = this.$refs.contactSection;
            const targetEl = el.$el || el;
            if (targetEl) {
                const offset = 60;
                const elementTop = targetEl.getBoundingClientRect().top + window.pageYOffset;
                const scrollPosition = elementTop - offset;

                window.scrollTo({
                top: scrollPosition,
                behavior: 'smooth',
                });
            }
          },
        },
        computed: {
            ...mapState("actionState", ["actions"]),
            ...mapGetters({
                isAboutMeVisible: `memberProfile/${storeGetters.isAboutMeVisible}`,
                isYpoCommunitiesVisible: `memberProfile/${storeGetters.isYpoCommunitiesVisible}`,
                isFormerMember: `memberProfile/${storeGetters.isFormerMember}`,
                currentUserId: `memberProfile/${storeGetters.currentUserId}`,
                isImpersonationMode: `auth/${storeGetters.isImpersonationMode}`,
                memberAdminControls: `auth/${storeGetters.memberAdminControls}`,
                myActivity: `memberProfile/${storeGetters.myActivity}`,
                profileConnection: `memberProfile/${storeGetters.profileConnection}`,
                isProfessionalExperienceVisible: `memberProfile/${storeGetters.isProfessionalExperienceVisible}`,
                contactInformation: `memberProfile/${storeGetters.contactInformation}`,
                assetsShortcutVisible: `memberProfile/${storeGetters.assetSummaryShortcut}`,
                chapterAdminEditable: `memberProfile/${storeGetters.chapterAdmin}`,
                userProfile: `memberProfile/${storeGetters.userProfile}`,
                canUserImpersonate: `memberProfile/${storeGetters.canUserImpersonate}`,
                isMobileAppBrowser: `${[storeGetters.isMobileAppBrowser]}`,
                routeConfigHideHeader: `${[storeGetters.routeConfigHideHeader]}`,
                routeConfigEngagementApp: `${[storeGetters.routeConfigEngagementApp]}`,
            }),
            isSavingImpersonation() {
              return this.actions[storeAction.saveImpersonationRole];
            },
            isCurrentUser() {
                return this.memberId === this.currentUserId || this.chapterAdminEditable;
            },
            isMyActivityVisible() {
                return this.myActivity && this.myActivity.length > 0;
            },
            loadGetUserProfileAction() {
                return this.actions[storeAction.getUserProfile];
            },
            manageImpersonationLabel() {
              return this.canUserImpersonate
                  ? memberProfileConstants.DISABLE_IMPERSONATION
                  : memberProfileConstants.ENABLE_IMPERSONATION;
            },
            canImpersonate() {
              return this.memberAdminControls && this.memberAdminControls.canImpersonate;
            },
            canAllowImpersonation() {
              return this.memberAdminControls && this.memberAdminControls.canAllowImpersonation;
            },
            displayAdminTools() {
              return !this.isCurrentUser && (this.canImpersonate || this.canAllowImpersonation);
            },
            canViewM2mx() {
              return this.userProfile && this.userProfile.ypoMemberType &&
              (this.userProfile.ypoMemberType === memberProfileConstants.MEMBER || this.userProfile.ypoMemberType === memberProfileConstants.SPOUSE);
            },
            isChapterManager() {
                return this.userProfile.ypoMemberType === memberProfileConstants.CHAPTER_ADMIN || this.userProfile.ypoMemberType === memberProfileConstants.CHAPTER_MANAGER;
            },
            isExchangeTestChapter() {
                return this.userProfile.chapterInfo.some(chapter => chapter.chapterId === this.memberProfileConstants.EXCHANGE_TEST_ID);
            },

        },
    };
</script>

<style lang="scss">
    @import "../../common/styles/_colors.scss";
    @import "../../common/styles/_responsive.scss";

    .member-profile {
        background: $white;
        padding: 24px;
        margin-top: 64px;

        .impersonate {
          border-bottom: 1px solid $ypo-open-blue-gray;
          padding-bottom: 25px;

          &--mobile {
            @include breakpointMin(md) {
              display: none;
            }
          }

          &--desktop {
            display: none;
            @include breakpointMin(md) {
              display: block;
            }
          }

          &__btn {
            width: 200px;
            background-color: $ypo-light-gray !important;
            color: $ypo-blue;
            font-weight: 600;
            margin: 0;

            &--disable {
              background-color: $ypo-cta !important;
              color: $white;
            }
          }
        }

        .back-to {
            margin-bottom: 30px;

            a {
                color: $ypo-dark-background-gray;
                font-size: 16px;
                font-weight: 600;
                line-height: 22px;
                text-decoration: none;

                i {
                    color: $ypo-dark-background-gray;
                    margin-right: 5px;
                }

            }
        }
        a {
            &:hover {
                color: $ypo-blue !important;
            }
        }

        h3 {
            border-radius: 4px 4px 0 0;
            background-color: $ypo_blue;
            box-shadow: 0 0 3px 0 rgba($black, 0.5);
            color: $white;
            font-size: 22px;
            font-weight: 500;
            line-height: 26px;
            padding: 15px 30px;
        }

        h2 {
            color: $ypo_blue;
            font-family: "Raleway", sans-serif;
            font-size: 22px;
            font-weight: 500;
            margin-bottom: 20px;
            line-height: 26px;

            span {
                color: $ypo-cta;
                font-size: 14px;
                font-weight: bold;
                line-height: 19px;
                cursor: pointer;
            }

            i {
                color: $ypo-dark-background-gray;
                font-size: 14px;
                position: relative;
                left: 0px;
                margin-right: 40px;
                cursor: pointer;
                top: -2px;
                &:hover{
                    color: $ypo-cta;
                }
                @include breakpoint(xs) {
                    min-width: 30px;
                }
            }

            em {
                color: $ypo-cta;
                font-family: "Noto Sans";
                font-size: 14px;
                line-height: 24px;
                font-style: normal;
                margin-left: 10px;
                cursor: pointer;
            }
        }

        h5 {
            color: $ypo_blue;
            font-size: 16px;
            font-weight: bold;
            line-height: 26px;
            margin-bottom: 20px;
        }

        .list-items {
            color: $ypo-gray-text;
            font-size: 14px;
            line-height: 35px;
            position: relative;
            padding-left: 65px;
            margin-top: 5px;

            &:before {
                content: "\f058";
                font-family: "Font Awesome 5 Free";
                color: $ypo-cta;
                font-weight: 600;
                position: absolute;
                top: 1px;
                left: 30px;
                font-size: 18px;
            }
        }

        .profile-links {
            border-bottom: 1px solid $ypo-open-blue-gray;
            margin: 30px 0;
            padding-bottom: 2px;
            padding-left: 20px;

            a {
                color: $ypo-cta;
                font-family: "Noto Sans";
                font-size: 12px;
                line-height: 16px;
                text-decoration: none;
                margin-right: 50px;
            }
        }

        .roles {
            border-bottom: 1px solid $ypo-open-blue-gray;
            margin-bottom: 20px;
            padding: 0 20px 20px 20px;

            strong {
                color: $ypo_blue;
                font-size: 14px;
                font-weight: bold;
                line-height: 24px;
                display: block;
            }

            span {
                color: $ypo-cta;
                font-size: 14px;
                line-height: 24px;
                display: block;
            }

            small {
                color: $ypo-gray-text;
                font-size: 12px;
                line-height: 24px;
                display: block;
            }

        }

        .contact-me {
            color: $ypo-cta;
            margin: 15px 0 20px 0;
            border-bottom: 1px solid $ypo-open-blue-gray;
            padding-bottom: 15px;

            h3 {
                margin-bottom: 15px;
            }
            small{
                display: block;
                font-size: 12px;
                line-height: initial;
                text-overflow: ellipsis;
                white-space: nowrap;
                overflow: hidden;
            }

            i {
                font-size: 28px;
                position: absolute;
                left: 30px;
                top: 12px;

                &.fa-phone {
                    transform: scaleX(-1);
                    top: 12px;
                }
                &.fa-envelope {
                    transform: scaleX(-1);
                    top: 4px;
                }
            }

            span {
                position: relative;
                width: 50%;
                display: inline-block;
                margin: 10px 0 10px 0;
                padding-left: 70px;
                line-height: 27px;
                font-size: 14px;
                padding-right: 10px;
                cursor: pointer;
                text-overflow: ellipsis;
                white-space: nowrap;
                overflow: hidden;

                a{
                    color: $ypo-cta !important;
                    text-decoration: none;
                }
            }
        }
    }

    .myprofile-popup {
        .v-card__title {
            background-color: $ypo-tile-border;
            color: $ypo-blue;
            font-family: Raleway;
            font-size: 24px;
            font-weight: 500;
            line-height: 30px;
            position: relative;

            i {
                color: $ypo-cta;
                position: absolute;
                right: 20px;
                cursor: pointer;
            }
        }

        .form-control {
            margin: 0 10px;
            min-height: 70px;
            position: relative;
        }

        .currently-work {
            position: absolute;
            right: 0;
        }

        .required-label {
            color: $ypo-blue;
            font-size: 14px;
            font-weight: bold;
            line-height: 24px;
            text-align: right;
            display: block;
        }

        .select-label {
            color: $ypo-blue;
            font-size: 14px;
            font-weight: bold;
            line-height: 20px;

            i {
                font-size: 18px;
                padding-left: 5px;
            }
        }
        .select-label-dateFeild {
            color: $ypo-blue;
            font-size: 14px;
            font-weight: bold;
            line-height: 20px;
            margin-left: 10px;

            i {
                font-size: 18px;
                padding-left: 5px;
            }
        }

        .error-label-enable {
            color: $ypo-red;
        }

        .error-label-disable {
            color: $ypo-blue;
        }

        h4 {
            color: $ypo-blue;
            font-family: Raleway;
            font-size: 20px;
            font-weight: 500;
            line-height: 24px;
            margin: 0 0 5px 10px;
        }

        .check-list {
            margin: 0 5px 10px 5px;
            border-bottom: 2px solid rgba($black, 0.2);
            padding: 10px 0 10px 0;
        }

        .row__list {
            margin-bottom: 20px;
        }

        .btn-row {
            padding: 0 0 30px 15px;
            @media (max-width: 767px) {
                .v-btn{
                    padding: 7px 20px;
                }
            }
            @include breakpoint(xs) {
                padding: 10px 0 10px 0px;
            }
        }

        .v-card__text {
            margin-right: 5px;
            width: auto;
        }

        .v-card__actions {
            border-top: 1px solid $ypo-medium-gray;
        }

        .details-view {
            color: $ypo-gray-text;
            font-size: 14px;
            line-height: 24px;
            margin-bottom: 30px;
            padding-top: 30px;
            border-top: 1px solid $ypo-medium-gray;

            &:first-child {
                border-top: none;
                padding-top: 0px;
            }

            h6 {
                color: $ypo-blue;
                font-size: 16px;
                font-weight: bold;
                line-height: 22px;
                margin: 0 0 5px 0;

                i {
                    color: $ypo-title-blue-gray;
                    margin-left: 5px;
                    cursor: pointer;
                }

                .note {
                    font-size: 14px;
                    color: $ypo-gray;
                    font-weight: 500;
                    margin: 0 0 0 15px;
                }
            }

            strong {
                margin-left: 20px;
                display: block;

                i {
                    color: $ypo-title-blue-gray;
                    cursor: pointer;
                    margin-left: 5px;
                }
            }

            small {
                margin-left: 20px;
                font-size: 14px;
                display: block;
            }

            i {
                color: $ypo-title-blue-gray;
                font-size: 14px;
                margin-left: 5px;
                cursor: pointer;
            }
        }

        .contact-edit {
            &__title {
                color: $ypo_blue;
                text-align: center;
                font-weight: 600;
                line-height: 16px;
                font-size: 12px;
                margin-bottom: 15px;
            }

            &__row {
                align-items: center;
                background: $ypo-light-gray-background;

                &:nth-child(2n + 1) {
                    background: $white;
                }

                strong {
                    display: block;
                    text-align: right;
                    margin-top: 20px;
                    color: $ypo_blue;
                }
            }
        }

        .autocomplete {
            position: relative;

            .autocomplete-results {
                padding: 0;
                margin: 0;
                border: 1px solid $white;
                height: 200px;
                overflow: auto;
                background: $ypo-extra-light-gray;
                position: absolute;
                z-index: 100;
                width: 100%;
            }

            .autocomplete-result {
                list-style: none;
                text-align: left;
                padding: 4px 2px;
                cursor: pointer;

                &.is-active,
                &:hover {
                    background-color: $ypo-cta;
                    color: $black;
                }
            }
        }

        .v-btn__content {
            text-transform: uppercase;
        }

        .save-to-profile {
            display: initial;
            color: $ypo_blue;
            margin-left: 15px;
            font-weight: bold;

            i {
                margin-right: 8px;
            }
            @include breakpoint(xs) {
                display: block;
                margin: 10px 0;
            }
        }

        .add-edit-btn {
            position: relative;

            .fa-plus-circle {
                position: absolute;
                left: 6px;
                bottom: 0px;
                font-size: 9px !important;
                background: $white;
                border-radius: 50%;
                padding: 1px;
            }
        }
    }
    .myprofile-popup {
        .text-number {
            .v-messages {
                display: none;
            }
        }

        .v-text-field .v-counter {
            margin-left: 0px !important;
        }

        .v-input--selection-controls__input+.v-label {
            font-weight: 400;
            font-size: 14px;
        }
    }

    @media (max-width: 1199px) {
        .member-profile {
            h3 {
                font-size: 18px;
            }
            .roles{
                padding: 0 0 20px 0;
            }
            .profile-links{
                padding-left: 0;
            }
        }
    }

    @media (max-width: 1023px) {
        .profile__block {
            padding-right: 0px !important;
        }
    }

    @media (max-width: 767px) {
        .member-profile {
            margin-bottom: 60px;
            padding: 35px 15px 10px 15px;
            margin-top: 55px;
            h3 {
                font-size: 18px;
                padding: 10px 20px;
            }

            .contact-me {
                i {
                    font-size: 20px;
                    top: 5px;
                }
            }

        }
        .myprofile-popup {
            .v-card__title {
                font-size: 16px;
                padding: 10px 40px 10px 10px;
            }
            .required-label {
                display: none;
            }
            .currently-work {
                position: relative;
            }
        }
        .contact-info {
            &__full-width {
                width: 850px;
            }
        }
    }
</style>
